import { Link } from "react-router-dom";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { newsItems } from "@/mocks/news";

export default function NewsSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15);
  const latestNews = newsItems.slice(0, 2);

  return (
    <section id="news" className="bg-[#f8f8f8] py-20 md:py-28">
      <div ref={ref} className="w-full px-4 md:px-8 max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-gold text-sm tracking-[4px] font-bold block mb-2">NEWS</span>
          <h2 className="text-2xl md:text-3xl font-bold text-navy">ニュース</h2>
          <div className="w-16 h-1 bg-gold mx-auto mt-4 rounded-full" />
        </div>

        <div className="space-y-5 mb-10">
          {latestNews.map((item, i) => (
            <div
              key={item.id}
              className={`bg-white rounded-xl p-6 md:p-8 border-l-4 border-gold transition-all duration-700 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <span className="text-gold text-sm font-bold tracking-wide block mb-2">
                {item.date}
              </span>
              <h3 className="text-base md:text-lg font-bold text-navy">{item.title}</h3>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/news"
            className="inline-flex items-center gap-2 border border-gold text-gold font-bold text-sm px-7 py-3 rounded-lg transition-all duration-300 hover:bg-gold hover:text-navy whitespace-nowrap"
          >
            Read More
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}